import { parsePhoneNumberFromString, parsePhoneNumber, isValidPhoneNumber, Metadata } from 'libphonenumber-js'
import countries from '../constant/countries'
import npaUsCad from '@/constant/npa_us_cad'

const metadata = new Metadata()

function isUSPhoneNumber(number) {
  try {
    if (!number) return ''
    if (number.length === 10) {
      number = '1' + number
    }
    const phoneNumber = parsePhoneNumberFromString('+' + number, 'US')
    const npa = number.substr(1, 3)
    return phoneNumber ? phoneNumber.country === 'US' && npaUsCad.includes(npa) : false
  } catch (error) {
    return false
  }
}

function beautifyPhone(number) {
  try {
    if (!number) return ''
    if (number.length === 10) {
      number = '1' + number
    }
    const beautified = parsePhoneNumber('+' + number)
    return beautified.formatNational()
  } catch (error) {
    return number
  }
}

function beautifyInternationalPhone(number) {
  try {
    if (!number) return ''
    if (number.length === 10 && isUSPhoneNumber(number)) {
      number = '1' + number
    }
    const beautified = parsePhoneNumber('+' + number)
    return beautified.formatInternational()
  } catch (error) {
    return number
  }
}

function formatPhone(number) {
  if (!number) return ''
  if (isNaN(+number)) return number
  number = parseInt(number).toString()
  if (isUSPhoneNumber(number)) {
    return beautifyPhone(number)
  }
  const _number = `+${number}`
  if (isValidPhoneNumber(_number)) {
    return _number
  }
  return number
}

function getFullNumber(number) {
  try {
    const _number = beautifyInternationalPhone(number)
    return _number.replace(/[^\d]/g, '')
  } catch (error) {
    return number
  }
}

function validateInternationalPhoneNumber(number) {
  if (number.length === 10) {
    return isUSPhoneNumber(number)
  }
  const phone = parsePhoneNumberFromString(
    `+${String(number).replace('+', '')}`
  )
  const npa = number.substr(1, 3)
  return phone ? npaUsCad.includes(npa) : false
}

function getCountryIsoBy(number) {
  if (!number) return {}
  const first4 = `+${number.slice(0, 4)}`
  const minLength = []
  const maxLength = []
  countries
    .filter(item => first4.includes(item.dial_code))
    .forEach(item => {
      metadata.selectNumberingPlan(item.code)
      const possibleLengths = metadata.numberingPlan.possibleLengths()
      minLength.push(...possibleLengths)
      maxLength.push(...possibleLengths.map(item => item + (metadata.numberingPlan?.metadata[0]?.length ?? 0)))
    })
  if (minLength.length === 0) return {}
  return {
    min: Math.min(...minLength),
    max: Math.max(...maxLength)
  }
}

function beautifyNumber (number) {
  if (!number) return ''
  try {
    const cleaned = `${number}`
    const match = cleaned.match(/^(1|)?(\d{0,3})?(\d{0,3})?(\d{0,4})?$/)
    return [
      match[1] ? '+1 ' : '',
      match[2] ? '(' : '',
      match[2],
      match[3] ? ') ' : '',
      match[3],
      match[4] ? '-' : '',
      match[4]
    ].join('')
  } catch (err) {
    return `(${number.slice(0, 3)}) ${number.slice(3, 6)}-${number.slice(6)}`
  }
}

export {
  formatPhone,
  getCountryIsoBy,
  beautifyNumber,
  validateInternationalPhoneNumber,
  getFullNumber
}
